import {useEffect, useState} from 'react';

const overlayParent = () => document.fullscreenElement || document.webkitFullscreenElement || document.body;

// Only descendants of the fullscreen element are painted by the browser.
export default function useOverlayParent() {
  const [parent, setParent] = useState(overlayParent);
  useEffect(() => {
    const update = () => setParent(overlayParent());
    document.addEventListener('fullscreenchange', update);
    document.addEventListener('webkitfullscreenchange', update);
    update();
    return () => {
      document.removeEventListener('fullscreenchange', update);
      document.removeEventListener('webkitfullscreenchange', update);
    };
  }, []);
  return parent;
}
